import MainComponent from './MainComponent';

export default MainComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/Main/MainContainer.js